import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=60a52e9c&scoped=true&"
import script from "./account-info.vue?vue&type=script&lang=js&"
export * from "./account-info.vue?vue&type=script&lang=js&"
import style0 from "./account-info.vue?vue&type=style&index=0&id=60a52e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a52e9c",
  null
  
)

export default component.exports